module.exports = "https://dev.stanwinstonschool.com/the_mandalorian.8e04d628a33656e7d431d14a5cffc09b.jpeg";